import { useTranslation } from 'react-i18next';

const JobCounter = ({ value, status, hiddenNoValue, className }) => {
  const { t } = useTranslation();

  if (hiddenNoValue && !value) {
    return null;
  }

  return (
    <div className={`${className} pt-3 pb-3`}>
      <h5 className="m-0 fw-light">{value || 0}</h5>
      <small>{t(`bots.jobs.card.${status}`)}</small>
    </div>
  );
};

export default JobCounter;
